export default "__VITE_ASSET__pWKP5w8Z__"